import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import PriceInfo from "web/react/components/price-info/price-info";
import { ShippingOptionPropType } from "web/types/buy-option";
import HintBubble from "../../hint-bubble/hint-bubble";
import SVGIcon from "../../svg-icon/svg-icon";
import styles from "./product-description-price-fb.css";


const PromoPropType = PropTypes.shape({
    message: PropTypes.string.isRequired,
    url: PropTypes.string,
    tcs: PropTypes.arrayOf(
        PropTypes.shape({
            message: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
        })
    ).isRequired,
});

function DisplayPromos({ promotion }) {
    if (!promotion) {
        return null;
    }
    let { message, url, tcs } = promotion;

    message = <span className={styles.promoText} dangerouslySetInnerHTML={{ __html: message }} />;

    let promoText;
    if (url) {
        promoText = <a href={url}>{message}</a>;
    } else {
        promoText = message;
    }

    tcs = tcs.map(({ message, url }) => (
        <a href={url} key={url}>
            {message}
        </a>
    ));
    let tcsPopup = <div className={styles.promoTCs}>{tcs}</div>;

    return (
        <div className={styles.promoArea}>
            <SVGIcon name="tag" className={styles.promoIcon} />
            {promoText}
            <HintBubble tooltipText={tcsPopup} className={styles.promoTCsIcon} />
        </div>
    );
}

DisplayPromos.propTypes = {
    promotion: PromoPropType,
};

export function ProductDescriptionPriceFB({
    absoluteUrl,
    className,
    currentPriceHtml,
    priceWithCurrencySymbol,
    isOnSale,
    isSavedForLater,
    leadUrl,
    promotion,
    retailerName,
    selectedShipping,
}) {
    return (
        <div
            className={classnames(className, styles.wrapper)}
            itemProp="offers"
            itemScope
            itemType="http://schema.org/Offer"
        >
            <meta itemProp="url" content={absoluteUrl} />
            <meta itemProp="availability" content="http://schema.org/InStock" />
            <meta itemProp="itemCondition" content="http://schema.org/NewCondition" />

            <div className={classnames(styles.priceWrapper)}>
                <div className={styles.priceDetailsWrapper}>
                    <PriceInfo
                        isOnSale={isOnSale}
                        retailerName={retailerName}
                        isSavedForLater={isSavedForLater}
                        leadUrl={leadUrl}
                        formattedPrice={priceWithCurrencySymbol}
                        selectedShipping={selectedShipping}
                        currentPriceHtml={currentPriceHtml}
                    />
                </div>
                <DisplayPromos promotion={promotion} />
            </div>
        </div>
    );
}

ProductDescriptionPriceFB.displayName = "ProductDescriptionPriceFB";

ProductDescriptionPriceFB.defaultProps = {
    isSavedForLater: false,
    isOnSale: false,
};

ProductDescriptionPriceFB.propTypes = {
    absoluteUrl: PropTypes.string.isRequired,
    className: PropTypes.string,
    currentPriceHtml: PropTypes.string.isRequired,
    isOnSale: PropTypes.bool,
    isSavedForLater: PropTypes.bool,
    leadUrl: PropTypes.string.isRequired,
    priceWithCurrencySymbol: PropTypes.string.isRequired,
    promotion: PromoPropType,
    retailerName: PropTypes.string.isRequired,
    selectedShipping: ShippingOptionPropType,
};

export default ProductDescriptionPriceFB;
